import { ArqNfs } from '../Entity/ArqNfs';

import { FindManyReq } from '../Entity/TypeormTypes';

import { ParamsGetNota } from '../types/NotaTypes';

import api from './apiEdCliente';

const PREFIX = 'api';
const ROUTE = 'edcliente/notaServico';

class ApiNfse {
  async getOne(params: FindManyReq<ArqNfs>) {
    const nota = await this.getMany({ ...params, take: 1 });
    return nota[0] as ArqNfs | undefined;
  }

  async getMany(query: FindManyReq<ArqNfs>) {
    try {
      const res = await api.post<ArqNfs[]>(`/${PREFIX}/${ROUTE}/get`, { query });
      const data = res.data;

      return data;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }

  async count(query: FindManyReq<ArqNfs>) {
    try {
      const res = await api.post<number>(`/${PREFIX}/${ROUTE}/count`, { query });
      const data = res.data;
      return data;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }

  async getPdfNfseEdCliente(params: ParamsGetNota) {
    try {
      const res = await api.post<string>(`/${PREFIX}/${ROUTE}/getPdfNfseEdCliente`, params);
      const data = res.data;
      return data;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }
}

const apiNfse = new ApiNfse();
export default apiNfse;
